import { Modal, ModalProps } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { VatDeclarationsDefinePayoutModalContextProvider } from './context/vatDeclarationsDefinePayoutModalContext'
import { ModalBody } from './elements/ModalBody'
import { ModalFooter } from './elements/ModalFooter'

type VatDeclarationsPeriodDefinePayoutModalProps = ModalProps

export const VatDeclarationsDefinePayoutModal = (props: VatDeclarationsPeriodDefinePayoutModalProps) => {
  const { t } = useTranslation()

  return (
    <VatDeclarationsDefinePayoutModalContextProvider modalId={props.id}>
      <Modal {...props} closable>
        <Modal.Header title={t('vat_declarations.define_payout_modal.title')} />
        <Modal.Body>
          <ModalBody />
        </Modal.Body>
        <Modal.Footer>
          <ModalFooter />
        </Modal.Footer>
      </Modal>
    </VatDeclarationsDefinePayoutModalContextProvider>
  )
}
